import { render, staticRenderFns } from "./ProjetBlocDescription.vue?vue&type=template&id=6eff581a&scoped=true&lang=true&"
import script from "./ProjetBlocDescription.vue?vue&type=script&lang=js&"
export * from "./ProjetBlocDescription.vue?vue&type=script&lang=js&"
import style0 from "./ProjetBlocDescription.vue?vue&type=style&index=0&id=6eff581a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eff581a",
  null
  
)

export default component.exports